<div class="col-lg-12 retalk-home-blq-img mb-md-flex-dir-col mt-lg-5 mt-md-2">

  <div class="col-lg-6 col-md-7 col-sm-12 col-12 retalk-home-blq-inner mb-5">

        <a [routerLink]="podcastUrl">
        <img [src]="podcastPoster" class="img-fluid" alt="{{carouselMainImg.imgAlt}}">
      </a>
  </div>

  <!-- <div class="carousel-inner" *ngFor="let item of carouselRetalkHome_items">       
    <div class="carousel-item" 
          [ngClass]="{'active': item.active}">
        <img [src]="item.imgSrc" class="d-block img-full-cover" alt="{{item.imgAlt}}">
    </div>
    
</div> -->
    <div class="col-lg-4 col-md-5 col-sm-12 col-12 retalk-home-blq-inner">

                 <div id="carousel2" class="carousel slide carousel-fade carouselTipo2" data-bs-ride="carousel">
                                  <div class="carousel-inner">       
                                      <div class="carousel-item"  *ngFor="let item of carouselRetalkHome_items; let i = index" [ngClass]="{'active': item.active}">
                                        
                                        <a [routerLink]="podcastUrl">
                                          <img [src]="item.imgSrc" class="d-block img-full-cover" alt="{{item.imgAlt}}">
                                          </a>
                                      </div>
                                      
                                  </div>
                                  <div class="controls bg-light">
                                         <div class="controls-blq">
                                                 <button class="carousel-control-prev" type="button" data-bs-target="#carousel2" data-bs-slide="prev">
                                                   <span class="carousel-control-prev-icon prueba" aria-hidden="true"></span>
                                                   <span class="visually-hidden">Previo</span>
                                                 </button>
                                                <button class="carousel-control-next" type="button" data-bs-target="#carousel2" data-bs-slide="next">
                                                   <span class="carousel-control-next-icon prueba" aria-hidden="true"></span>
                                                   <span class="visually-hidden">Siguiente</span>
                                                </button>
                                         </div>       
                                   </div>
                 </div><!-- fin carousel-->
                   
  </div>

 
</div>